export const REQUEST_PERMIT_LOADING = 'REQUEST_PERMIT_LOADING';
export const REQUEST_PERMIT_SUCCESS = 'REQUEST_PERMIT_SUCCESS';
export const REQUEST_PERMIT_ERROR = 'REQUEST_PERMIT_ERROR';
export const REQUEST_PERMIT_CLEAR_ERROR = 'REQUEST_PERMIT_CLEAR_ERROR';
export const REQUEST_PERMIT_CLEAR_APPLICATION = 'REQUEST_PERMIT_CLEAR_APPLICATION';

export const REQUEST_PERMIT_FETCH_PROPERTY_DETAILS_SUCCESS = 'REQUEST_PERMIT_FETCH_PROPERTY_DETAILS_SUCCESS';

export const REQUEST_PERMIT_FETCH_APPLICATION_DETAILS_SUCCESS = 'REQUEST_PERMIT_FETCH_APPLICATION_DETAILS_SUCCESS';

export const REQUEST_PERMIT_DELETE_BROKER_SUCCESS = 'REQUEST_PERMIT_DELETE_BROKER_SUCCESS';

export const REQUEST_PERMIT_ADD_BUYER_SUCCESS = 'REQUEST_PERMIT_ADD_BUYER_SUCCESS';

export const REQUEST_PERMIT_SET_BUYER_TRANSACTION_PERCENTAGE = 'REQUEST_PERMIT_SET_BUYER_TRANSACTION_PERCENTAGE';

export const REQUEST_PERMIT_CHANGE_WORKFLOW_STEP = 'REQUEST_PERMIT_CHANGE_WORKFLOW_STEP';

export const REQUEST_PERMIT_SAVE_APPLICATION_SUCCESS = 'REQUEST_PERMIT_SAVE_APPLICATION_SUCCESS';

export const REQUEST_PERMIT_FETCH_DOCUMENTS_SUCCESS = 'REQUEST_PERMIT_FETCH_DOCUMENTS_SUCCESS';
export const REQUEST_PERMIT_FETCH_BREAKDOWN_SUCCESS = 'REQUEST_PERMIT_FETCH_BREAKDOWN_SUCCESS';
export const REQUEST_PERMIT_RESET_BREAKDOWN_SUCCESS = 'REQUEST_PERMIT_RESET_BREAKDOWN_SUCCESS';

export const SET_PERMIT_EXCLUSIVITY = 'SET_PERMIT_EXCLUSIVITY';

export const REQUEST_PERMIT_FIELD_CHANGE = 'REQUEST_PERMIT_FIELD_CHANGE';
export const REQUEST_PERMIT_FORM_ERROR = 'REQUEST_PERMIT_FORM_ERROR';

export const REQUEST_PERMIT_FETCH_GOVERNMENT_COMPANIES_SUCCESS = 'REQUEST_PERMIT_FETCH_GOVERNMENT_COMPANIES_SUCCESS';

export const REQUEST_PERMIT_CLEAR_GOVERNMENT_COMPANIES = 'REQUEST_PERMIT_CLEAR_GOVERNMENT_COMPANIES';

export const REQUEST_PERMIT_FETCH_NON_UAE_USERS = 'REQUEST_PERMIT_FETCH_NON_UAE_USERS';
export const REQUEST_PERMIT_FETCH_NON_UAE_USERS_SUCCESS = 'REQUEST_PERMIT_FETCH_NON_UAE_USERS_SUCCESS';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';
// Action for intiating the request permit process
export const PERMIT_INITIATEOR = 'REQUEST_PERMIT_INITIATOR';

export const PERMIT_PERMIT_TYPE = 'REQUEST_PERMIT_PERMIT_TYPE';

export const PERMIT_PERMIT_DURATION = 'REQUEST_PERMIT_PERMIT_DURATION';

export const REQUEST_PERMIT_SET_BROKER_DETAILS = 'REQUEST_PERMIT_SET_BROKER_DETAILS';

export const REMOVE_REQUEST_PERMIT_PROPERTIES = 'REMOVE_REQUEST_PERMIT_PROPERTIES';
export const REMOVE_REQUEST_PERMIT_PROPERTIES_SUCCESS = 'REMOVE_REQUEST_PERMIT_PROPERTIES_SUCCESS';
export const REMOVE_REQUEST_PERMIT_PROPERTIES_ERROR = 'REMOVE_REQUEST_PERMIT_PROPERTIES_ERROR';

export const GET_REQUEST_PERMIT_BUILDINGS = 'GET_REQUEST_PERMIT_BUILDINGS';
export const GET_REQUEST_PERMIT_BUILDINGS_SUCCESS = 'GET_REQUEST_PERMIT_BUILDINGS_SUCCESS';
export const GET_REQUEST_PERMIT_BUILDINGS_ERROR = 'GET_REQUEST_PERMIT_BUILDINGS_ERROR';

export const GET_REQUEST_PERMIT_UNITS = 'GET_REQUEST_PERMIT_UNITS';
export const GET_REQUEST_PERMIT_UNITS_SUCCESS = 'GET_REQUEST_PERMIT_UNITS_SUCCESS';
export const GET_REQUEST_PERMIT_UNITS_ERROR = 'GET_REQUEST_PERMIT_UNITS_ERROR';

export const ADD_REQUEST_PERMIT_PROPERTIES = 'ADD_REQUEST_PERMIT_PROPERTIES';
export const ADD_REQUEST_PERMIT_PROPERTIES_SUCCESS = 'ADD_REQUEST_PERMIT_PROPERTIES_SUCCESS';
export const ADD_REQUEST_PERMIT_PROPERTIES_ERROR = 'ADD_REQUEST_PERMIT_PROPERTIES_ERROR';
export const ADD_REQUEST_PERMIT_VALIDATION_ERROR = 'ADD_REQUEST_PERMIT_VALIDATION_ERROR';
export const ADD_REQUEST_PERMIT_UNIT_VALIDATION_ERROR = 'ADD_REQUEST_PERMIT_UNIT_VALIDATION_ERROR';

export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const REQUEST_PERMIT_PROPERTY_SUCCESS = 'REQUEST_PERMIT_PROPERTY_SUCCESS';
